import $ from 'jquery';
import * as ShopifyCart from '@shopify/theme-cart';

import { globalEventBus } from '@pixelcabin/ui-utils';

export const flyoutCart = 'flyoutCart';

export const mutations = {
  FETCH_STATE: 'FETCH_STATE',
  FETCH_STATE_SUCCESS: 'FETCH_STATE_SUCCESS',
  FETCH_STATE_ERROR: 'FETCH_STATE_ERROR',
  TOGGLE_OPEN: 'TOGGLE_OPEN',
  UPDATE: 'UPDATE'
};

export const actions = {
  fetchState: 'fetchState',
  addItem: 'addItem',
  updateItem: 'updateItem',
  removeItem: 'removeItem'
};

export const flyoutCartStore = () => {
  const $body = $(document.body);

  return {
    namespaced: true,
    state: Object.assign({
      isLoading: false,
      items: [],
      token: '',
      subTotal: 0,
      itemCount: 0,
      isOpen: false
    }),
    getters: {
      isEmpty: (state) => {
        return state.items.length === 0;
      },

      hasSubscriptionItems(state) {
        return state.items.some((item) => item.hasSubscription);
      }
    },
    mutations: {
      [mutations.FETCH_STATE](state) {
        state.isLoading = true;
      },

      [mutations.FETCH_STATE_SUCCESS](state) {
        state.isLoading = false;
      },

      [mutations.FETCH_STATE_ERROR](state) {
        state.isLoading = false;
      },

      [mutations.UPDATE](state, toUpdate) {
        Object.entries(toUpdate).forEach(
          ([key, value]) => (state[key] = value)
        );
      },

      [mutations.TOGGLE_OPEN](state, isOpen) {
        if (isOpen !== undefined) {
          state.isOpen = isOpen;
        } else {
          state.isOpen = !state.isOpen;
        }

        if (state.isOpen) {
          $body.addClass('flyout-cart-is-open');
        } else {
          $body.removeClass('flyout-cart-is-open');
        }
      }
    },
    actions: {
      [actions.fetchState]({ commit, state, getters }) {
        commit(mutations.FETCH_STATE);
        globalEventBus.emit('flyoutCart.fetchState.start');

        Promise.all([
          ShopifyCart.getState(),
          // custom AJAX endpoint that supplies metafield data to cart items
          fetch('/cart?view=ajax.json').then((res) => {
            return res.json().catch(console.error);
          })
        ])
          .then(([shopifyCartState, cartMetaData]) => {
            const { items, token, total_price, item_count } = shopifyCartState;

            const updatedItems = items.map((item) => {
              const {
                featured_image,
                final_line_price,
                handle,
                key,
                id,
                product_title,
                product_type,
                properties,
                quantity,
                variant_title,
                url
              } = item;

              const metaDatum = cartMetaData[id];

              const title = metaDatum?.original_title
                ? metaDatum.original_title
                : product_title;

              return {
                handle,
                image: {
                  alt: featured_image.alt,
                  aspectRatio: featured_image.aspect_ratio,
                  src: featured_image.url
                },
                key,
                id,
                price: final_line_price,
                productTitle: title,
                properties,
                quantity,
                type: product_type,
                url,
                variantTitle: variant_title,
                hasSubscription: metaDatum.has_subscription
              };
            });

            commit(mutations.UPDATE, {
              token,
              subTotal: total_price,
              itemCount: item_count,
              items: updatedItems
            });

            commit(mutations.FETCH_STATE_SUCCESS);

            globalEventBus.emit('flyoutCart.fetchState.end', {
              ...state,
              ...getters
            });
          })
          .catch((err) => {
            console.error(err);
            commit(mutations.FETCH_STATE_ERROR);
          });
      },

      [actions.addItem](
        { commit, dispatch },
        { variantId, quantity, sellingPlanId }
      ) {
        globalEventBus.emit('flyoutCart.addItem.start', variantId);

        commit(mutations.FETCH_STATE);

        const items = [
          {
            id: variantId,
            quantity,
            selling_plan: sellingPlanId
          }
        ];

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: `application/json`
          },
          body: JSON.stringify({ items: items })
        })
          .then(() => {
            globalEventBus.emit('flyoutCart.addItem.end', variantId);

            dispatch(actions.fetchState);
            commit(mutations.TOGGLE_OPEN, true);
          })
          .catch((error) => {
            return error.json();
          })
          .then((data) => {
            if (data && data.status === 422 && data.message === 'Cart Error') {
              document.dispatchEvent(
                new CustomEvent('addToCart.failed', {
                  detail: {
                    response: data
                  }
                })
              );
              console.error(data);
            }
          });
      },

      [actions.updateItem]({ commit, dispatch }, { item, quantity }) {
        globalEventBus.emit('flyoutCart.updateItem.start', item);

        commit(mutations.FETCH_STATE);

        const { key } = item;

        return ShopifyCart.updateItem(key, { quantity })
          .then(() => {
            globalEventBus.emit('flyoutCart.updateItem.end', item);

            dispatch(actions.fetchState);
          })
          .catch(console.error);
      },

      [actions.removeItem]({ commit, dispatch }, { item }) {
        globalEventBus.emit('flyoutCart.removeItem.start', item);

        commit(mutations.FETCH_STATE);

        const { key } = item;

        ShopifyCart.removeItem(key)
          .then(() => {
            globalEventBus.emit('flyoutCart.removeItem.end', item);

            dispatch(actions.fetchState);
          })
          .catch(console.error);
      }
    }
  };
};
